import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './LoadIndicator.pcss';
import {getMessage} from '../common/Message';
import {Icon} from 'epic-diesel-common';
import {svgs, sizes} from 'epic-diesel-common/src/constants';

export default class LoadIndicator extends React.Component {
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        /* Props to check if it is currently loading state */
        isLoading: PropTypes.bool,
        messages: PropTypes.object
    };

    render() {
        const {isLoading, messages} = this.props;

        const loadingMessage = messages
            ? getMessage(messages, 'epic.affiliate.common.loading')
            : '';

        const loading = !isLoading ? (
            ''
        ) : (
            <div className={styles.loader}>
                <Icon className={styles.icon} icon={svgs.LOADING} size={sizes.LARGE} />
                <div className={styles.text}>
                    <h3>{loadingMessage}</h3>
                </div>
            </div>
        );
        const loadingClass = classNames({[styles.isLoading]: isLoading});
        return (
            <div>
                {loading}
                <div className={loadingClass}>{this.props.children}</div>
            </div>
        );
    }
}
